import { MonitoringSession } from '../../../../../types/DeployerControlMonitoring.types';
import { SessionScorePill } from './SessionScorePill';

interface SessionHistoryListProps {
  sessions: MonitoringSession[];
  loading: boolean;
  selectedSessionId: string | null;
  onSelectSession: (sessionId: string) => void;
}

export function SessionHistoryList({
  sessions,
  loading,
  selectedSessionId,
  onSelectSession
}: SessionHistoryListProps) {
  if (loading) {
    return <span className="text-sm text-gray-500">Loading sessions…</span>;
  }

  if (sessions.length === 0) {
    return (
      <span className="text-sm text-gray-500">
        No monitoring sessions yet — run an analysis to get started.
      </span>
    );
  }

  return (
    <div className="flex flex-col gap-2">
      <div className="flex flex-col">
        <span className="text-sm font-medium text-gray-700">Analysis History</span>
        <span className="text-xs text-gray-500">
          Previous Article 26 Compliance runs — select one to view its results below.
        </span>
      </div>
      <div className="flex flex-col divide-y divide-gray-100 border border-gray-200 rounded-lg">
        {sessions.map((session) => (
          <button
            key={session.id}
            type="button"
            onClick={() => onSelectSession(session.id)}
            className={`flex items-center justify-between px-4 py-3 text-left ${
              session.id === selectedSessionId ? 'bg-purple-50' : ''
            }`}
          >
            <div className="flex flex-col">
              <span className="text-sm text-gray-800">
                {new Date(session.createdAt).toLocaleString()}
              </span>
              <span className="text-xs text-gray-500">
                {session.triggerType === 'MANUAL' ? 'Manual' : 'Scheduled'} · {session.status}
              </span>
            </div>
            <SessionScorePill
              overallStatus={session.overallStatus}
              overallScorePercent={session.overallScorePercent}
            />
          </button>
        ))}
      </div>
    </div>
  );
}
